export default "__VITE_ASSET__Cp$pzhZV__"